export enum BillingFrequency {
    Unspecified = 0,
    Annually = 1
}